import apiService from "./api.service";


class EntityService {
    async get(entry) {
        const result = await apiService.get('/entity/search/' + entry)
            .then(function (response) {
                console.log('entitySearch');

                const entityData = response.data.Result.map((row) => {
                    const { _id: id } = row;
                    row.display = `${row.name}`;
                    if (row.email != null) row.display += ", " + row.email;
                    return { id, ...row };
                });

                console.log(entityData);
                return { data: entityData };
            })
            .catch(function (error) {
                throw new Error('get entity error: ' + JSON.stringify(error));
            });

        return result;
    }
}

export default new EntityService();


// WEBPACK FOOTER //
// ./src/services/entity.service.js